import { CadorReference } from './cador-reference';
import { Personne } from './personne';

export class PersonneReference {

    libelleConfigurable: CadorReference;

    personnesReferences: Personne[] = [];

}
